<template>
  <main class="content">
    <el-card>
      <div slot="header" class="clearfix">
        <span>商品参数设置</span>
        <el-button style="float: right;" type="primary" size="small" @click="saveProductConfig">保存</el-button>
      </div>
      <el-form ref="productParams" :model="productParams" size="small">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="无审核价格下限(%)">
              <el-input-number v-model="productParams.priceThresholdLower" controls-position="right" :max="0" :step="0.01"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="无审核价格上限(%)">
              <el-input-number v-model="productParams.priceThresholdUpper" controls-position="right" :min="0" :step="0.01"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
  </main>
</template>

<script>
export default {
  data() {
    return {
      productParams: {
        priceThresholdLower: 0,
        priceThresholdUpper: 0,
      }
    };
  },
  methods: {
    initData() {
      this.getProductConfig();
    },
    getProductConfig() {
      const that = this;
      this.$axios.get("/admin/settings/system/product")
      .then(function(response) {
        let resp = response.data;
        if(resp.header.status === 0) {
          that.productParams.priceThresholdLower = resp.data.priceThresholdLower;
          that.productParams.priceThresholdUpper = resp.data.priceThresholdUpper;
        }
      });
    },
    saveProductConfig() {
      const that = this;
      this.$axios.post("/admin/settings/system/product", that.productParams)
      .then(function(response) {
        let resp = response.data;
        if(resp.header.status === 0) {
          that.$notify({
            title: '成功',
            message: '数据保存成功',
            type: 'success'
          });
        } else {
          that.$notify.error({
            title: '错误',
            message: resp.header.msg
          });
        }
      });
    },
  },
  created() {
      this.initData();
  },
}
</script>

<style>

</style>